export const calcPercentage = (value1: number = 0, value2: number = 0): number | undefined => {
  if (value1 === null || !value1) {
    return undefined
  }
  if (value2 === null || !value2) {
    return undefined
  }
  if (value1 === 0 && value2 > 0) {
    return 100
  }
  //if (value1 === 0 && value2 === 0) {
  if (value1 === 0) {
    return 0
  }
  if (value1 >= 0 && value2 === 0) {
    return -100
  }

  return ((value2 - value1) / Math.abs(value1)) * 100
}

export const calcPercentage2 = (value1: number = 0, value2: number = 0): number | undefined => {
  if (value1 === null || !value1) {
    return undefined
  }
  if (value2 === null || !value2) {
    return undefined
  }

  const diff = (((value1 || 0) / (value2 || 0)) * 100).toFixed(2)

  return Number(diff)
}
